export default [

    // *===============================================---*
    // *--------- Calender - Marketing  ---------------------------------------*
    // *===============================================---*
    {
        path: '/marketing/leads',
        name: 'marketing-leads',
        component: () => import('@/views/marketing/leads/main.vue'),
        meta:{
            pageTitle:'Marketing Leads',
            breadcrumb: [
                {
                    text: 'Marketing Leads',
                    active:true,
                },
            ],
            permission: 'Permissions.Marketing.View'
        },
    },
]